import React from 'react'
import { Modal } from 'antd'
import { close_icon, CorrectTick, dark_close, hourglass_icon2, xmarkIcon } from '../../assets/images'
import { Divider, SpinnerLinear, CountMetricCard } from '../common/atoms'

const UploadStatusModal = ({ data, uploadStatus = 'pending', description = '', metric_liners = [], visible, close, allow_bug_dwnld = false, bugReport }) => {
  const status = uploadStatus === 'pending'
  const modalIcon = <img src={status ? hourglass_icon2 : CorrectTick} alt='mail_icon' className='inline-block my-6 h-14 w-14' />
  const closeIcon = <img src={close_icon} alt='close_icon' className='inline-block' />
  return (
    <div
        className={`fixed z-20 inset-0 overflow-y-auto ${visible ? '' : 'hidden'}`}
        aria-labelledby='modal-title'  
        aria-modal='true'
      >
        <div className='flex items-end justify-center  text-center sm:block sm:p-0'>
          <div
            className='fixed inset-0 opacity-50 transition-opacity'
            aria-hidden='true'
            style={{backgroundColor : '#000000'}}
            onClick={close}
          >
          </div>
          <span className='sm:inline-block sm:align-middle sm:h-screen' aria-hidden='true'>
            &#8203;
          </span>  
          <div className="inline-block  align-bottom pb-12 bg-white text-left overflow-hidden shadow-xl transform transition-75 sm:my-8 sm:align-middle sm:max-w-2xl sm:w-full"
          style={{zIndex : 1000, borderRadius : '10px'}}
          >
        <div className='text-center'>
        <div className='flex flex-row-reverse px-6 pt-6'>
          <img src={dark_close} alt='closeIcon' className='cursor-pointer' onClick={close} />
        </div>
           {modalIcon}
           <p className='mb-0 mt-1 text-gray-700 text-xl font-semibold'>{status ? 'Your file is being processed' : 'File has been uploaded successfully'}</p>
            <p className='mb-0 mt-4 text-gray-600 text-base'>{status ? 'Please wait a few seconds, while we are processing your data' : 'We are processing the data, you will receive a confirmation mail within an hour.'}</p>
            <p className='mb-0 mt-2 text-gray-600 mx-8 text-base'>{status ? '' : description}</p>
          </div>
          <Divider classes='mt-8' />
          <div className='mt-4 mx-6'>
            <span className='text-base font-semibold text-gray-600'>Live data upload status</span>
            {status && <SpinnerLinear classes='ml-3 h-4 w-4' />}
            <div className='mt-3 grid grid-cols-2 gap-4'>
              <CountMetricCard svgsrc={CorrectTick} metricValue={data[0]} metricDescription={status ? `${metric_liners[0]} data enqueued`:`${metric_liners[0]} data processed`} classes='bg-gray-100 px-2 py-6' valueClasses='text-xl' desClasses='pt-2' />
              {status && <CountMetricCard svgsrc={CorrectTick} metricValue={data[1]} metricDescription={metric_liners[1]} classes='bg-gray-100 px-2 py-6' valueClasses='text-xl' desClasses='pt-2' />}
              <CountMetricCard svgsrc={CorrectTick} metricValue={data[2]} metricDescription={metric_liners[2]} classes='bg-gray-100 px-2 py-6' valueClasses='text-xl' desClasses='pt-2' />
              <CountMetricCard svgsrc={xmarkIcon} metricValue={data[3]} metricDescription={metric_liners[3]} allow_bug_dwnld={allow_bug_dwnld} bugReport={bugReport} classes='bg-gray-100 px-2 py-6' valueClasses='text-xl' desClasses='pt-2' />
            </div>
          </div>
          </div>
        </div>
      </div>   
  )
}

export default UploadStatusModal